import { EventClass } from "../../../entities/courseEvent/courseEvent";
import { BusinessException } from "../../../exceptions/exceptions";
import { User } from "../../../entities/entities";

export class EventClassRules {
  static alreadyEnrolledError = (
    user: User,
    eventClass: EventClass
  ): BusinessException | void => {
    if (!eventClass.enrollUsers) return;

    const enrolledUsersIds = eventClass.enrollUsers.map(user => user.id);
    if (enrolledUsersIds.includes(user.id)) {
      return new BusinessException(
        "Você já está matriculado nessa turma.",
        "ALREADY_ENROLLED"
      );
    }
  };

  static maxCapacityReachedError = (
    user: User,
    eventClass: EventClass
  ): BusinessException | void => {
    if (!eventClass.enrollUsers) return;

    if (eventClass.maxCapacity === eventClass.enrollUsers.length) {
      return new BusinessException(
        "Não há mais vagas para essa turma.",
        "MAX_CAPACITY_REACHED"
      );
    }
  };

  static eventClassIsFinishedError = (
    eventClass: EventClass
  ): BusinessException | void => {
    if (eventClass.finishedAt) {
      return new BusinessException(
        "Esta turma já foi finalizada.",
        "EVENT_CLASS_FINISHED"
      );
    }
  };
}
